import styles from "./StudentStaffRatio.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  { _id: "1", room: "Room 1", studentCount: 1, staffCount: 2 },
  { _id: "2", room: "Room 1", studentCount: 24, staffCount: 72 },
  { _id: "3", room: "Room 1", studentCount: 1, staffCount: 2 },
  { _id: "4", room: "Room 1", studentCount: 1, staffCount: 2 },
  { _id: "4", room: "Room 1", studentCount: 1, staffCount: 2 },
  { _id: "4", room: "Room 1", studentCount: 1, staffCount: 2 },
];

// GCD-based ratio function
const getRatio = (a, b) => {
  if (b === 0) return "N/A";
  const gcd = (x, y) => (y === 0 ? x : gcd(y, x % y));
  const d = gcd(a, b);
  return `${a / d}:${b / d}`;
};

function StudentStaffRatio() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const getColumnData = (data) => {
    return data?.map((item) => {
      return {
        room: (
          <span style={{ color: "var(--Primary_Color)", fontWeight: 400 }}>
            {item.room}
          </span>
        ),
        studentCount: item.studentCount.toString().padStart(2, "0"),
        staffCount: item.staffCount.toString().padStart(2, "0"),
        ratio: getRatio(item.studentCount, item.staffCount),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    { title: "Room", accessor: "room" },
    { title: "Students", accessor: "studentCount" },
    { title: "Staffs", accessor: "staffCount" },
    { title: "Ratio", accessor: "ratio" },
  ];

  return (
    <>
     
        <div className={styles.headerContainer} style={{ padding: "1rem" }}>
          <h4
            style={{
              color: "var(--Primary_Color)",
              fontWeight: "400",
              marginBottom: "1.5rem",
            }}
          >
            Student Staff Ratio
          </h4>

          <div className={styles.totalstudentcard}>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
              <div className={styles.paginationTable}>
                <PaginationTable
                  data={displayData}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  setCurrentPage={setCurrentPage}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      
      <div >{<CopyRight />}</div>
    </>
  );
}

export default StudentStaffRatio;
